import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router/index";
import BootstrapVue from "bootstrap-vue";
import VueCookies from "vue-cookies";
import Vuex from "vuex";
import VueAnalytics from "vue-analytics";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { store } from "@/store";
import Component from "vue-class-component";
import VuePapaParse from "vue-papa-parse";
import consts from "./consts";
const options = {
  confirmButtonColor: "#41b882",
  cancelButtonColor: "#ff7674",
};

Vue.use(VueAnalytics, {
  id: consts.googleAnalyticsTrackingId,
  router,
});

Vue.use(BootstrapVue);
Vue.use(VueCookies);
Vue.use(Vuex);
Vue.use(VuePapaParse);
Vue.config.productionTip = false;

Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate",
]);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// eslint-disable-next-line

// @todo enable this after fixing the styles
// import 'bootstrap/dist/css/bootstrap.css'

/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   components: {
//     App
//   },
//   template: '<App/>'
// })
